import { render, staticRenderFns } from "./AppccTopDetail.vue?vue&type=template&id=29c0768a"
import script from "./AppccTopDetail.vue?vue&type=script&lang=js"
export * from "./AppccTopDetail.vue?vue&type=script&lang=js"
import style0 from "./AppccTopDetail.vue?vue&type=style&index=0&id=29c0768a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports